<app-patient-search
  class="mb-10"
  [search]="searchCriteria"
  [list]="patientList"
  [refreshTime]="refreshTime"
  [hideAfter]="hidePatientSearch"
  (onActionClick)="patientOnSelect($event)"
></app-patient-search>
<div class="patient-detail fixed-height">
  <div class="flex">
    <div class="col-8">
      <div *ngIf="patientInfoDisplay">
        <img
          class="user-img"
          [src]="patientImage ? patientImage : './assets/images/user.png'"
        />
        <label class="patient-name-label"> {{ patientInfoDisplay }}</label
        >&nbsp;
        <img
          class="user-img"
          [src]="isVip ? './assets/images/email-icons/vip-icon.png' : null"
          *ngIf="isVip"
          style="height: 28px"
        />
      </div>
      <div *ngIf="!patientInfoDisplay">
        <label class="patient-name-label">{{
          "MergeListPage.noPatientAudit" | translate
        }}</label>
      </div>
    </div>
  </div>
</div>

<div class="encounter-container mt-10" style="height:70vh;overflow: auto;">
    <table mat-table [dataSource]="fieldRows" class="mat-elevation-z8">
        <!-- Field Name Column -->
        <ng-container matColumnDef="field">
          <th mat-header-cell *matHeaderCellDef> {{ "MergeListPage.auditDateorUserName" | translate }} </th>
          <td mat-cell *matCellDef="let element"> {{ element.field }} </td>
        </ng-container>
      
        <!-- Dynamic Audit Columns -->
        <ng-container *ngFor="let col of auditColumns" [matColumnDef]="col">
          <th mat-header-cell *matHeaderCellDef> {{ col }} </th>
          <!-- <td mat-cell *matCellDef="let element"> {{ element[col] || '-' }} </td> -->
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.field === ('MergeListPage.patientPhoto' | translate); else normalValue">
              <img *ngIf="element[col]" [src]="element[col]" class="audit-patient-photo" />
              <span *ngIf="!element[col]">-</span>
            </ng-container>
            <ng-template #normalValue>
              {{ element[col] || '-' }}
            </ng-template>
          </td>
        </ng-container>
      
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      
</div>

<div class="right section-grey">
  <button
    matTooltip="{{ 'payerInfo.back' | translate }}"
    (click)="backToRegistration()"
    class="btnOrange"
    mat-mini-fab
  >
    <mat-icon> keyboard_arrow_left</mat-icon>
  </button>
</div>
